import { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
function SwitchCompany({ email }) {
	let companies = []

	if (email.includes('mayekawa'))
		companies = [
			{ id: 112582, name: 'Mayekawa AR', fileImage: null, roleId: 1 },
			{ id: 112587, name: 'Mayekawa Centroamerica', fileImage: null, roleId: 1 },
			{ id: 112595, name: 'Mayekawa CL', fileImage: null, roleId: 1 },
			{ id: 112596, name: 'Mayekawa CO', fileImage: null, roleId: 1 },
			{ id: 112594, name: 'MAYEKAWA DO BRASIL EQUIPAMENTOS INDUSTRIAIS LTDA', fileImage: null, roleId: 1 },
			{ id: 112589, name: 'Mayekawa EC', fileImage: null, roleId: 1 },
			{ id: 113258, name: 'Mayekawa LATAM', fileImage: null, roleId: 1 },
			{ id: 112597, name: 'Mayekawa MX', fileImage: null, roleId: 1 },
			{ id: 112598, name: 'Mayekawa PE', fileImage: null, roleId: 1 },
		]

	if (email.includes('artecola'))
		companies = [
			{ id: 115037, name: 'ARTECOLA CHILE', fileImage: null, roleId: 1 },
			{ id: 115038, name: 'ARTECOLA COLOMBIA', fileImage: null, roleId: 1 },
			{ id: 115040, name: 'ARTECOLA PERU', fileImage: null, roleId: 1 },
		]

	const [value, setValue] = useState('')
	const history = useHistory()
	const location = useLocation()

	useEffect(() => {
		const user = localStorage.getItem('user')
		const userData = user ? JSON.parse(user) : null
		if (userData) {
			setValue(userData.id.toString())
		}
	}, [])

	const handleChange = event => {
		const selectedCompanyId = event.target.value

		const selectedCompany = companies.find(company => company.id.toString() === selectedCompanyId)

		if (selectedCompany) {
			localStorage.setItem('user', JSON.stringify(selectedCompany))
			setValue(selectedCompanyId)
			const targetRoute = '/app'

			if (location.pathname === targetRoute) {
				window.location.reload()
			} else {
				history.push(targetRoute)
			}
		}
	}

	return (
		<select onChange={handleChange} value={value} className='rounded-3 p-2'>
			<option value=''>Cambiar la empresa</option>
			{companies.map((company, index) => (
				<option key={index} value={company.id}>
					{company.name}
				</option>
			))}
		</select>
	)
}

export default SwitchCompany
